import React, { useEffect } from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

// styles
import { WrapApp } from './App.styles'

// component
import Login from './components/Login/Default'
import BankLogin from './components/Login/Bank'
import Main from './components/Main'
import PrivateRoute from './components/Control/PrivateRoute'

// constant
import { MAIN } from './constant/path'
import { AUTHENTICATED_ERR } from './redux/notifies/types'
import { env, WEE_ENV, BANK_ENV } from './constant/environmentTypes'
import { FACEPAY_PORTAL_LOGIN } from './helper/localStore'

// action
import { logoutAction } from './redux/login/action'

const App = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  switch (env) {
    case BANK_ENV:{
      const dataLogin = localStorage.getItem(FACEPAY_PORTAL_LOGIN)
      let pageTitle = "Facepay for Banks"
      if (dataLogin) {
        let login = JSON.parse(dataLogin)
        if (login.supplierShortName && login.supplierShortName.length > 0) {
          pageTitle = `Facepay for ${login.supplierShortName}`
        }
      }
      document.title = pageTitle
    }
      break;
  
    default:
      document.title ="Admin Facepay BackOffice" 
      break;
  }

  const { notifiesReducer } = useSelector((state) => ({
    notifiesReducer: state.notifiesReducer
  }))

  useEffect(() => {
    if(Object.keys(notifiesReducer).includes(AUTHENTICATED_ERR)){
      dispatch(logoutAction(history, false))
    }
  }, [JSON.stringify(notifiesReducer)]);

  return (
    <WrapApp>
      <Switch>
        <Route exact path="/">
          {
            env === WEE_ENV
            ?  <Login />
            :  <BankLogin />
          }
        </Route>
        <PrivateRoute path={`/${MAIN}`}>
          <Main />
        </PrivateRoute>
        <Redirect to="/" />
      </Switch>
    </WrapApp>
  )
}

export default App
